export const PLAN_USER_ROLE = {
  MENTOR: "mentor",
  YOUTH: "youth",
  INITIATOR: "initiator",
  GUIDE: "guide",
  GUARDIAN: "guardian",
}

export const PLAN_USER_ROLE_LABELS = {
  [PLAN_USER_ROLE.MENTOR]: "Mentor",
  [PLAN_USER_ROLE.YOUTH]: "Student",
  [PLAN_USER_ROLE.INITIATOR]: "Initiator",
  [PLAN_USER_ROLE.GUIDE]: "Guide",
  [PLAN_USER_ROLE.GUARDIAN]: "Guardian",
}
